import { Link } from 'react-router-dom';

export default function PageCta() {
  return (
    <section className="bg-[#5C5470] py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <h2
          className="font-bold text-white mb-4"
          style={{ fontSize: 'clamp(1.5rem, 2.5vw, 2.125rem)', lineHeight: '1.4' }}
        >
          準備好為您的未來築起保障了嗎？
        </h2>
        <p
          className="text-white/80 mb-10"
          style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
        >
          無論是初步諮詢、保單健檢，或是有任何保險疑問，都歡迎與我聯繫。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-3.5 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-colors duration-200 cursor-pointer"
            style={{ fontSize: '1.0625rem' }}
          >
            <i className="ri-calendar-check-line"></i>
            立即預約諮詢
          </Link>
          <a
            href="https://lin.ee/6XFYSq2"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white px-8 py-3.5 rounded-full font-semibold whitespace-nowrap hover:bg-white/10 transition-colors duration-200 cursor-pointer"
            style={{ fontSize: '1.0625rem' }}
          >
            <i className="ri-line-fill"></i>
            加入 LINE 諮詢
          </a>
        </div>
      </div>
    </section>
  );
}